import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

// ─── Section Header Icons (from TED Toolbox) ─────────────────────

export const BrainIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 18V5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 18a4 4 0 0 0 2-7.464" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 18a4 4 0 0 1-2-7.464" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const Building2Icon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M10 12h4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 8h4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 21v-3a2 2 0 0 0-4 0v3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const CalendarIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M8 2v4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 2v4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect width="18" height="18" x="3" y="4" rx="2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 10h18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const LayersIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const RoadmapIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 5.764v15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 3.236v15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

// ─── Service Line Icons ───────────────────────────────────────────

export const SearchIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="m21 21-4.3-4.3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
)

export const BarChartIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 20V10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 20V4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 20v-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const MailIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect width="20" height="16" x="2" y="4" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const PaletteIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="13.5" cy="6.5" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    <circle cx="17.5" cy="10.5" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    <circle cx="8.5" cy="7.5" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    <circle cx="6.5" cy="12.5" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" fill="none" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
)

export const CodeIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="m16 18 6-6-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m8 6-6 6 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const MegaphoneIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="m3 11 18-5v12L3 13v-2z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

export const PenToolIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m2.3 2.3 7.286 7.286" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="11" cy="11" r="2" fill="none" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
)

export const TargetIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="2" fill="none" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
)

export const ShareIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="18" cy="5" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="6" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="18" cy="19" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="m8.59 13.51 6.83 3.98" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="m15.41 6.51-6.82 3.98" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
)

// ─── Service Line Icon Map ────────────────────────────────────────

export const SERVICE_LINE_ICONS: Record<string, React.FC<SvgIconProps>> = {
  seo: SearchIcon,
  ana: BarChartIcon,
  emm: MailIcon,
  ux: PaletteIcon,
  web: CodeIcon,
  ppc: TargetIcon,
  content: PenToolIcon,
  social: ShareIcon,
  pr: MegaphoneIcon,
}

// Color map per service line
export const SERVICE_LINE_COLORS: Record<string, string> = {
  seo: '#4AA17B',
  ana: '#5B8DEF',
  emm: '#E87722',
  ux: '#A855F7',
  web: '#3B82F6',
  ppc: '#EF4444',
  content: '#DAA520',
  social: '#EC4899',
  pr: '#14B8A6',
}
